import { render, staticRenderFns } from "./UploadLibraryThumbnailDialog.vue?vue&type=template&id=2b0fca8e"
import script from "./UploadLibraryThumbnailDialog.vue?vue&type=script&lang=ts"
export * from "./UploadLibraryThumbnailDialog.vue?vue&type=script&lang=ts"
import style0 from "./UploadLibraryThumbnailDialog.vue?vue&type=style&index=0&id=2b0fca8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports